export const LABELS = {
  TITLE: 'Sorted Applications',
  SUBTITLE: (amount: number) =>
    `You have ${amount === 0 ? 'no current' : `${amount} submitted`} applications`,
  BUTTON: 'View applications',
};
